export default __webpack_public_path__ + "static/media/fullLogo.9d2de3d9.svg";